import { createAsyncTypes } from 'utils/ActionCreator'
import { differenceInCalendarDays, isValid } from 'utils/dateUtils'

import {
  CAMPAIGN_TYPES,
  DEFAULT_MANAGER_REPORT_DAY_OF_WEEK,
  DEFAULT_MANAGER_REPORT_REMINDERS_THRESHOLD,
  PARTICIPANTS_EXCLUDE_FILTER_VALUES,
} from 'containers/AwarenessCenter/constants'

import { PLAYLIST_MODES } from './playlist'

const typeKey = 'AwarenessCenter/WizardTrainingCampaign'

export const GET_DEFAULT_TRAINING_DATA_ASYNC = createAsyncTypes(
  'GET_DEFAULT_TRAINING_DATA',
  typeKey
)

export const SYNC_PLAYLIST_REMINDERS_ASYNC = createAsyncTypes('SYNC_PLAYLIST_REMINDERS', typeKey)

export const SYNC_PLAYLIST_ASSIGNMENT_ASYNC = createAsyncTypes('SYNC_PLAYLIST_ASSIGNMENT', typeKey)

export const TRAINING_EVENTS = {
  CAMPAIGN_LAUNCHED: 'trn:campaign_launched',
  PLAYLIST_REORDERED: 'trn:playlist_reordered',
  PLAYLIST_SINGLE_FALLBACK: 'trn:playlist_single_fallback',
  PLAYLIST_DUPLICATED: 'trn:playlist_duplicated',
}

export const CHANGE_MESSAGE_STEP_PROPERTY = `${typeKey}/CHANGE_MESSAGE_STEP_PROPERTY`
export const VALIDATE_MESSAGE_STEP_FIELDS = `${typeKey}/VALIDATE_MESSAGE_STEP_FIELDS`
export const TOGGLE_SAVE_MAIL_SIGNATURE = `${typeKey}/TOGGLE_SAVE_MAIL_SIGNATURE`

export const DEFAULT_COLLECTION_PERIOD = 7
export const DEFAULT_REMINDERS_INTERVAL = 2
export const SENDING_EMAILS_PERIOD = 2

export const DEFAULT_TRAINING_PROPERTIES = {
  sendReminderEveryXBusinessDays: DEFAULT_REMINDERS_INTERVAL,
  sendCampaignSummaryToCampaignReportRecipients: true,
  sendCompletionEmail: true,
  sendManagerReportEveryXDays: null,
  managerReportRemindersThreshold: DEFAULT_MANAGER_REPORT_REMINDERS_THRESHOLD,
  managerReportDayOfWeek: DEFAULT_MANAGER_REPORT_DAY_OF_WEEK,
}

export const DEFAULT_TRAINING_CAMPAIGN_OBJECT = {
  // name: '',
  // defaultLocaleId: null,
  // timezone: null,
  // closeTime: '',
  // launchDate: '',
  // launchTime: '',

  participants: {
    page: 1,
    selectorLoader: false,
    modalLoader: false,
    error: null,
    modalSearch: '',
    excludeFilter: PARTICIPANTS_EXCLUDE_FILTER_VALUES.INCLUDED,
    included: {},
    excluded: {},
    items: [],
    meta: {
      count: 0,
    },
    includedSelectionIds: [],
    excludedSelectionIds: [],
  },
  randomizedScenarios: true, // default
  selectedTrainingVideo: [],
  otherModeSelection: [],
  playlistMode: PLAYLIST_MODES.SINGLE,
  messageStep: {
    fields: {
      subject: '',
      message: '',
      includeLogo: true,
      useDesignedImage: true,
      mailSignature: '',
      fromEmail: '',
    },
    validations: {},
  },
  saveMailSignature: false,
  trainingReminders: [],
  // What the last sync fetched; null until a sync runs, then the baseline for "still unedited".
  reminderDefaults: null,
  triggerBasedCampaignData: null,
  maxRemindersPerParticipant: null,
  isEndDateWasManuallyChanged: false,
  completionNotificationSettings: {
    notifyRecipients: true,
    notifyDirectManager: true,
  },
  ...DEFAULT_TRAINING_PROPERTIES,
}

export const getTrainingCollectionPeriod = (campaignType, closeTime, launchDate) => {
  if (
    campaignType !== CAMPAIGN_TYPES.TRAINING ||
    !isValid(new Date(closeTime)) ||
    !isValid(new Date(launchDate))
  )
    return null

  return differenceInCalendarDays(new Date(closeTime), new Date(launchDate))
}
